<template>
  <div class="row align-items-center">
    <div class="col-sm-3">
      <div class="icon-portrait text-muted text-center">
        <base-icon icon="portrait" />
      </div>
    </div>
    <div class="col-sm-9">
      <div><strong>{{ name }}</strong></div>
      <div class="mb-3">{{ role }}</div>
      <div>
        <strong>T: </strong>
        <a :href="`tel:${phone}`">{{ phone }}</a>
      </div>
      <div class="text-truncate">
        <strong>E: </strong>
        <a :href="`mailto:${email}`" :title="email">{{ email }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactCard',

  props: {
    email: String,
    name: { required: true, type: String },
    noBorder: Boolean,
    phone: String,
    role: String
  }
}
</script>

<style>
.icon-portrait {
  font-size: 6rem;
}
</style>
